import Avatar from '@atlaskit/avatar/Avatar';
import { AutoDismissFlag, FlagGroup } from '@atlaskit/flag';
import MentionIcon from '@atlaskit/icon/glyph/mention';
import React, { createContext, useContext, useState } from 'react';

import { FlagsProviderProps, AddFlagProps, Flag, FlagContextType } from './types';

const FlagContext = createContext<FlagContextType | undefined>(undefined);

export const useFlags = () => {
  const context = useContext(FlagContext);

  if (!context) {
    throw new Error('useFlags must be used within a FlagsProvider');
  }

  return context;
};

export const FlagsProvider = ({ children }: FlagsProviderProps) => {
  const [flags, setFlags] = useState<Flag[]>([]);

  const addFlag = ({ profilePicture, title, description, actions }: AddFlagProps) => {
    setFlags((prevFlags) => {
      const newFlagId = prevFlags.length + 1;
      const newFlags = [
        { id: newFlagId, profilePicture, title, description, actions },
        ...prevFlags,
      ];
      return newFlags;
    });
  };

  const handleDismiss = () => {
    setFlags(flags.slice(1));
  };

  return (
    <FlagContext.Provider value={{ addFlag }}>
      {children}
      <FlagGroup onDismissed={handleDismiss}>
        {flags.map((flag: Flag) => (
          <AutoDismissFlag
            id={flag.id}
            icon={
              flag.profilePicture ? (
                <Avatar src={flag.profilePicture} label="" />
              ) : (
                <MentionIcon label="" />
              )
            }
            key={flag.id}
            title={flag.title}
            description={flag.description}
            actions={flag.actions}
          />
        ))}
      </FlagGroup>
    </FlagContext.Provider>
  );
};
